import { Link } from 'react-router-dom';

const MODULES = {
  structure: { root: '/exam-library', rootLabel: 'Exam library' },
  bank: { root: '/question-banks', rootLabel: 'Question banks' }
};

// Shared header for exam-scoped pages. Shows a breadcrumb back to the module
// root, the exam title/description, stat chips and a switcher to flip between
// the structure view (exam library) and the question view (question bank).
export default function ExamPageHeader({ examId, active = 'structure', title, description, stats }) {
  const module = MODULES[active] || MODULES.structure;
  return (
    <div className="exam-header">
      <div className="exam-header-top">
        <nav className="breadcrumb" aria-label="Breadcrumb">
          <Link to={module.root}>{module.rootLabel}</Link>
          <span className="breadcrumb-sep">/</span>
          <span className="breadcrumb-current">{title}</span>
        </nav>
        <div className="module-switch">
          <Link className={`module-pill ${active === 'structure' ? 'active' : ''}`} to={`/exam-library/${examId}`}>
            Exam structure
          </Link>
          <Link className={`module-pill ${active === 'bank' ? 'active' : ''}`} to={`/question-banks/${examId}`}>
            Question bank
          </Link>
        </div>
      </div>
      <h2>{title}</h2>
      {description && <p className="exam-header-desc">{description}</p>}
      {stats && (
        <div className="stat-chips">
          <span className="stat-chip"><b>{stats.sections ?? 0}</b> sections</span>
          <span className="stat-chip"><b>{stats.topics ?? 0}</b> topics</span>
          <span className="stat-chip"><b>{stats.questions ?? 0}</b> questions</span>
        </div>
      )}
    </div>
  );
}
